<script lang="ts">
import { navigate } from "svelte-navigator";

    import type { Form } from "../Model/Form";
    import type { FormInstance } from "../Model/FormInstance";
    import { formsService } from "../Services";
    import FormBtn from "./FormBtn.svelte";
    import SignaturesCount from "./SignaturesCount.svelte";
    import Slide from "./Slide.svelte";
    import Slider from "./Slider.svelte";

    type InstanceForm = {
        instance: FormInstance,
        form: Form,
    }

    export let instances: FormInstance[];

    let items: InstanceForm[] = [];

    $: loadForms(instances);

    async function loadForms(instances: FormInstance[]) {
        
        const forms = await Promise.all(instances.map(({ formId }) => formsService.getForm(formId)));

        items = instances.map(instance => ({
            instance,
            form: forms.find(({ id }) => id === instance.formId)
        }));

    }

    function onClick(instance: FormInstance) {
        navigate(`/formulario/${instance.id}`);
    }

</script>

<style lang="scss">

    .signatures-count {
        position: absolute;
        z-index: 2;
        top: 1rem;
        left: 1rem;
    }

</style>

<Slider slidesPerView={3} slidesPerGroup={3}>
    {#each items as { form, instance }}
    <Slide>
        <div class="signatures-count">
            <SignaturesCount {instance} />
        </div>
        <FormBtn form={form} on:click={() => onClick(instance)} />
    </Slide>
    {/each}
</Slider>    